import { useState } from "react"
import { NotificationIcons, MyToolIcons, ReferUserIcons, RenewIcons } from '../../global/Icons';
import { HelpIcon, MoreIcon, PublicationIcon, PublicationSaveIcon, SupportIcon } from "../../global/icon/icon";

export const NavigationStates = () => {
    const [tabs, setTabs] = useState({
        top: [
            {name:'Notifications', subdir:'/notification', ref: '/psl/notification', steps:'ninth-step', not_active: <NotificationIcons fill="#333333" />, active: <NotificationIcons  fill="#3D77E9" />},
            {name:'MyTools', subdir:'#', ref: '__mytools', steps:'tenth-step', not_active:<MyToolIcons fill="#292D32" />, active:<MyToolIcons fill="#3D77E9" stroke="#3D77E9" />},
        ],
        mtop: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/notification', steps: 'fifth-step', not_active: <NotificationIcons fill="#fff" />, active: <NotificationIcons fill="#3D77E9" />},
            {name:'MyTools', className:'tenth-step', subdir:'#', ref: '__mytools', steps: 'six-step', not_active:<MyToolIcons fill="#FFFFFF" stroke="#FFFFFF" />, active:<MyToolIcons fill="#3D77E9" stroke="#3D77E9"/>},
        ],
        topLeft: [
            {name:'Publication', sub_name:'', subdir:'/psl/publication?tab=article', ref: 'publication', steps:'first-step', not_active:<PublicationIcon type="default" height="20px" width="20px"/>, active:<PublicationIcon type="active" height="20px" width="20px"/>},
            // {name:'Bulletin', sub_name:'', subdir:'/psl/bulletin', ref: 'bulletin', steps:'second-step', not_active:<BulletinIcon type="not_active" />, active:<BulletinIcon type="active" />},
            {name:'Save', sub_name:'', subdir:'/psl/save', ref: 'save', steps:'second-step', not_active:<PublicationSaveIcon type="default" height="20px" width="20px"/>, active:<PublicationSaveIcon type="active" height="20px" width="20px"/>},
        ],
        bottomLeft: [
            {name:'Help', sub_name:'', subdir:'/psl/help', ref: 'help', steps:'third-step', not_active:<HelpIcon type="default" height="20px" width="20px"/>, active:<HelpIcon type="active" height="20px" width="20px"/>},
            {name:'Support', sub_name:'', subdir:'/psl/support', ref: 'support', steps:'fourth-step', not_active: <SupportIcon type="default" height="20px" width="20px"/>, active: <SupportIcon type="active" height="20px" width="20px"/>},
        ],
        msetting: [
            {name:'Refer a Hero Users', subdir:'/psl', ref: 'psl', steps: 'sixth-step', not_active:<ReferUserIcons fill="#fff" stroke="#A2A3A9"/>, active:<ReferUserIcons fill="#333333" stroke="#333333"/>},
            {name:'System Updates', subdir:'/psl', ref: 'psl', steps: 'seventh-step', not_active:<RenewIcons fill="none" stroke="#89A594"/>, active:<RenewIcons fill="#333333" stroke="#333333"/>},
        ],
        mobile: [
            {name:'Publication', sub_name:'', subdir:'/psl/publication?tab=article', ref: 'publication', steps:'first-step', not_active:<PublicationIcon type="default" height="20px" width="20px"/>, active:<PublicationIcon type="active" height="20px" width="20px"/>},
            {name:'Save', sub_name:'', subdir:'/psl/save', ref: 'save', steps:'second-step', not_active:<PublicationSaveIcon type="default" height="20px" width="20px"/>, active:<PublicationSaveIcon type="active" height="20px" width="20px"/>},
            {name:'More', sub_name:'', subdir:'/psl/more', ref: 'more', steps:'third-step', not_active:<MoreIcon type="default" height="20px" width="20px"/>, active:<MoreIcon type="active" height="20px" width="20px"/>},
        ]
    })
    const [tc, setTc] = useState({open: true, list: false})
    const [leftBar, setLeftbar] = useState(true)
    const [myTool, setMyTool] = useState(false)
    const [help, setHelp] = useState({
        toggled: false,
        feature_list: [
            {name: 'Tour me', ref: 'tour-me', toggled: false, type: 'dropdown', sub_feature_list: [
                {name: 'General', ref: 'general'},
                {name: 'Publication', ref: 'publication'},
                {name: 'Save', ref: 'save'},
            ]},
            {name: `FAQ's`, ref: 'faq', toggled: false, type: 'link', sub_feature_list: []}
        ]
    })  

    return {
        tabs: {data: tabs, set: setTabs},
        tc: {data: tc, set: setTc},
        leftBar: {data: leftBar, set: setLeftbar},
        myTool: {data: myTool, set: setMyTool},
        help: {data: help, set: setHelp},
    }
}